module.exports = __webpack_public_path__ + "static/media/info.433a89af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/admin/info.svg
// module id = 1051
// module chunks = 0